<template>
  <a-drawer width="35%" :label-col="6" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="ruleName" >
        <span slot="label" ><a-tooltip>{{$t('名称')}}<template slot="title">{{$t('名称')}}</template></a-tooltip> </span>
        <a-input v-model="form.ruleName" :maxLength="32" :placeholder="$t('请输入')+'名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="startTime" >
        <span slot="label" ><a-tooltip>{{$t('开始时间')}}<template slot="title">{{$t('开始时间')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.startTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="endTime" >
        <span slot="label" ><a-tooltip>{{$t('结束时间')}}<template slot="title">{{$t('结束时间')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.endTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="score" >
        <span slot="label" ><a-tooltip>{{$t('每日签到积分')}}<template slot="title">{{$t('每日签到积分')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.score" style="width: 100%" :min="0" :max="9999999" :placeholder="$t('请输入')+'每日签到积分'" />
      </a-form-model-item>
      <a-form-model-item prop="extraDay" >
        <span slot="label" ><a-tooltip>{{$t('连续签到天数')}}<template slot="title">{{$t('连续签到天数')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.extraDay" style="width: 100%" :min="0" :max="100" :placeholder="$t('请输入')+'连续签到天数'" />
      </a-form-model-item>
      <a-form-model-item prop="extraScore" >
        <span slot="label" ><a-tooltip>{{$t('连续签到额外积分')}}<template slot="title">{{$t('连续签到额外积分')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.extraScore" style="width: 100%" :min="0" :max="9999999" :placeholder="$t('请输入')+'连续签到额外积分'" />
      </a-form-model-item>
      <a-form-model-item prop="limitMonthScore" >
        <span slot="label" ><a-tooltip>{{$t('每月上限')}}<template slot="title">{{$t('每月上限')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.limitMonthScore" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'每月上限'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{$t('备注')}}<template slot="title">{{$t('备注')}}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getScoreSignRule, addScoreSignRule, updateScoreSignRule } from '@/api/user/scoreSignRule'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import moment from 'moment';


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        ruleName: null,
        startTime: null,
        endTime: null,
        score: null,
        extraDay: null,
        extraScore: null,
        limitMonthScore: null,
        remark: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        ruleName: [{required: true, message: this.$t('名称') + this.$t('不能为空'), trigger: 'blur'}],
        startTime: [{required: true, message: this.$t('开始时间') + this.$t('不能为空'), trigger: 'change'}],
        endTime: [{required: true, message: this.$t('结束时间') + this.$t('不能为空'), trigger: 'change'}],
        score: [{required: true, message: this.$t('每日签到积分') + this.$t('不能为空'), trigger: 'blur'}],
        extraDay: [{required: true, message: this.$t('连续签到天数') + this.$t('不能为空'), trigger: 'blur'}],
        extraScore: [{required: true, message: this.$t('连续签到额外积分') + this.$t('不能为空'), trigger: 'blur'}],
        limitMonthScore: [{required: true, message: this.$t('每月上限') + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        ruleName: null,
        startTime: null,
        endTime: null,
        score: null,
        extraDay: null,
        extraScore: null,
        limitMonthScore: null,
        remark: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getScoreSignRule({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateScoreSignRule(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addScoreSignRule(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
